import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comissao',
  templateUrl: './comissao.component.html',
  styleUrls: ['./comissao.component.scss']
})
export class ComissaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
